module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#cpynte",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgements#ack"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("The Evening News Is Bad for Your Health")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("You Can Drown in the Fountain of Youth")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O.J. in the Morning, G&T at Night")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beware of Animal Crackers in Your Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Over Your Shoulder and onto the Green")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If You Can’t Pet ’Em, Don’t Get ’Em")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Are Who You Are Until You Aren’t")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Are Harboring a Snake in the AT&T Bushes")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Out of the Rat Race and into the Trap")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Either Use It or Lose It")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coming to the Reunion? Thanks, but No Thanks.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kidnap Yourself for Thirty Minutes Every Day")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What You Can’t Hear Can’t Hurt You")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Stockpiling Years Are Now Paying Dividends")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nip Your Nuptial Before Your Nuptial Nips You")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yes, Richard, There Is a Santa Claus")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World Is Your Oyster, So Shuck It")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When You Leave What You Leave, Do You Leave It?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s All Hanging in the Balance")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Past Is Sometimes the Present")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Are the Motorman, Conductor, and Passenger")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Train Is Pulling Out, Step Gently On")])]), _vm._v(" "), _c('p', {
    staticClass: "cct-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By the Light of the Lopsided Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adc",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Also by A. E. Hotchner")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/aboutauthor#abt",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#cpy",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0